import { Profile } from "@/models/database/profiles/profile.model";
import { FC } from "react";
import { ReactComponent as PlusIcon } from "../../../../../../assets/actions/plus.svg";
import {
  Avatar,
  Box,
  Button,
  Flex,
  Heading,
  TextField,
} from "@radix-ui/themes";

export const SettingsProfileHistory: FC<{
  currentUser: Profile;
  setOpenModal: any;
  setIsAvatar: any;
  setImgSrc: any;
  setIsLoading: any;
  isLoading: any;
  handleInputChange: any;
}> = ({
  currentUser,
  setOpenModal,
  setIsAvatar,
  setImgSrc,
  setIsLoading,
  isLoading,
  handleInputChange,
}) => {
  return (
    <Flex gap="3" wrap="wrap" direction="column" mb="3">
      <Box>
        <input
          accept="image/*"
          type="file"
          className=""
          onChange={(e) => {
            handleInputChange(e);
            return setOpenModal(true);
          }}
        />
      </Box>

      <Heading as="h2" size="3">
        History
      </Heading>
      <Flex gap="3" wrap="wrap">
        {currentUser.profileLogoUrlHistory &&
          currentUser.profileLogoUrlHistory?.map((item: string, index) => {
            const key = `profileHistoryItem_${index}`;
            return (
              <Box
                key={key}
                onClick={() => {
                  setImgSrc(item);
                  setIsAvatar(false);
                  setIsLoading(null);
                }}
              >
                <Avatar src={item} fallback="A" radius="full" size="5" />
              </Box>
            );
          })}
      </Flex>
    </Flex>
  );
};
